// extracted by mini-css-extract-plugin
export default {"VerificationCodeItem":"VerificationCodeItem--qxZQD","code-request":"code-request--R6fkG"};